import PinnedUserAvailable from "@/components/notifications/PinnedUserAvailable.vue"
import InvitedToRoom from "@/components/notifications/InvitedToRoom.vue"
import Broadcast from "@/components/notifications/sidebar/Broadcast.vue"
import InvitedToRoomSidebar from "@/components/notifications/sidebar/InvitedToRoom.vue"
import PinnedUser from "@/components/notifications/sidebar/PinnedUser.vue"
import InvitationResponse from "@/components/notifications/InvitationResponse.vue"

function getRoomInviteMeta({rootGetters}, data) {
    if (data.sentOrReceived === "received") {
        return {
            sidebarNotificationComponent: InvitedToRoomSidebar,
            modalComponent: InvitedToRoom,
            // Can't clear if the invite has not been responded to
            canClear: data.status !== 'sent',
            desktopNotification: {
                from: data.title,
                icon: rootGetters['api/media/getAvatarUrl'](data.senderId),
                body: data.message,
                tag: data.id,
                type: data.type
            }
        }
    } else if (data.sentOrReceived === "sent") {
        return {
            modalComponent: InvitationResponse,
            sidebarNotificationComponent: InvitedToRoomSidebar,
            // Can't clear if the invite has not been responded to
            canClear: data.status !== 'sent',
            desktopNotification: {
                from: data.title,
                icon: rootGetters['api/media/getAvatarUrl'](data.recipientId),
                body: data.response,
                tag: data.id,
                type: data.type
            }
        }
    }
}


function getPinsResponseMeta({rootGetters}, data) {
    const fullName = `${data.data.firstName} ${data.data.lastName}`
    return {
        modalComponent: PinnedUserAvailable,
        sidebarNotificationComponent: PinnedUser,

        // Can only clear if the pin is cancelled or expired
        canClear: data.response === 'Cancelled' || data.response === 'Expired' || data.response === 'Handled',
        desktopNotification: {
            from: `${fullName} is available!`,
            icon: rootGetters['api/media/getAvatarUrl'](data.data.pinnedUserId),
            body: `You pinned ${data.data.firstName}, and they're now available. Do you want to invite them to a Room?`,
            type: data.type,
            tag: data.id
        }
    }
}

function getBroadcastMeta(data) {
    return {
        sidebarNotificationComponent: Broadcast,
        canClear: true,
        desktopNotification: {
            from: data.title,
            icon: "",
            body: data.message,
            tag: data.id,
            type: data.type
        }
    }
}

const state = {
}

const getters = {
    getNotificationMeta(state, getters, rootState, rootGetters) {
        const context = {state,getters,rootState,rootGetters}
        return (data) => {
            if (!data) return undefined
            switch (data.type) {
                case "pinsResponse":
                    return getPinsResponseMeta(context, data)
                case "pinsUpdated":
                    return getPinsResponseMeta(context, data)
                case "pinsCancelled":
                    return getPinsResponseMeta(context, data)
                case "pinsExpired":
                    return getPinsResponseMeta(context, data)
                case "pinsInvite":
                    return getPinsResponseMeta(context, data)
                case "pinsHandled":
                    return getPinsResponseMeta(context, data)
                case "roomInvite":
                    return getRoomInviteMeta(context, data)
                case "spaceBroadcastMessage":
                    return getBroadcastMeta(data)
            }
        }
    }
};

const mutations = {
};

const actions = {
};

export default {
    state,
    getters,
    mutations,
    actions
};
